import React from 'react';

import { Stack, Typography } from '@mui/material';

import { Section as Container } from '../styled';
import Card from './Card';
import { List } from './styled';
import { LeanSection } from './types';

function Learn() {
  return (
    <Container>
      <Stack>
        <Typography variant="h3">Learn</Typography>
        <List>
          {Object.values(LeanSection).map((section) => (
            <Card key={section} section={section} />
          ))}
        </List>
      </Stack>
    </Container>
  );
}

export default Learn;
